import { render, staticRenderFns } from "./page7.vue?vue&type=template&id=b5bb2202&scoped=true&"
import script from "./page7.vue?vue&type=script&lang=js&"
export * from "./page7.vue?vue&type=script&lang=js&"
import style0 from "./page7.vue?vue&type=style&index=0&id=b5bb2202&lang=scss&scoped=true&"
import style1 from "./page7.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bb2202",
  null
  
)

export default component.exports